import type React from "react";

import I18n from "pro-features/components/WithTranslation/src/I18n";

import type { IStatefullIconSwitcherItem } from "./StatefullIconSwitcher";
import { StatefullIconSwitcher } from "./StatefullIconSwitcher";

interface IDashboardWizardTrafficSourcesProps {
    isActive: boolean;
    availableTrafficSources: IStatefullIconSwitcherItem[];
    selectedTrafficSource: number;
    changeTrafficSource: (trafficSource: string) => void;
}
const DashboardWizardTrafficSources: React.FC<IDashboardWizardTrafficSourcesProps> = ({
    isActive,
    availableTrafficSources,
    selectedTrafficSource,
    changeTrafficSource,
}) => {
    const onSelect = (item) => {
        changeTrafficSource(item);
    };
    if (isActive) {
        return (
            <div className="devices">
                <h4>
                    <I18n>home.dashboards.wizard.settings.title</I18n>
                </h4>
                <h5>
                    <I18n>home.dashboards.wizard.trafficSource.title</I18n>
                </h5>
                <StatefullIconSwitcher
                    items={availableTrafficSources}
                    selected={selectedTrafficSource}
                    onItemClicked={onSelect}
                />
            </div>
        );
    } else {
        return <div></div>;
    }
};

export default DashboardWizardTrafficSources;
